import * as React from 'react';
import { ToolbarConfig, MenuConfig } from '@tencent/workbench';
import i18n from '@i18next/i18n';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import { TOOLBAR_ADDON } from '@editor/src/img/pageIndex';
import { wrapIdForBig, wrapIdForFold } from '@framework/workbench/util/wrap-id-util';

export const config = {
    id: ActionType.INSERT_ALL,
    tipMsg: i18n.t('插入表格/链接等'),
    title: i18n.t('插入'),
    icon: TOOLBAR_ADDON,
};

export const TOOLBAR_ITEMS: ToolbarConfig[] = [
    {
        name: config.id,
        // 这张资源图有问题，没有尺寸
        icon: <img src={config.icon} alt={''} style={{
            width: 20,
            height: 20,
        }}/>,
        text: i18n.t('插入'),
        tooltip: config.tipMsg,
        style: {
            width: 'auto',
        },
    },
    {
        name: wrapIdForBig(config.id),
        icon: <img src={config.icon} alt={''}/>,
        text: i18n.t('插入'),
        tooltip: config.tipMsg,
        style: {
            width: 'auto',
        },
    },
    {
        name: wrapIdForFold(config.id),
        icon: <img src={config.icon} alt={''}/>,
        text: i18n.t('插入'),
        tooltip: config.tipMsg,
        hasArrow: true,
        style: {
            width: 'auto',
        },
    },
];

export const MENU_CONFIGS: MenuConfig[] = [
    {
        name: config.id,
        content: config.title,
    },
];
